import React, { useEffect } from 'react';
import Navbar from '../components/Navbar'; // Adjust path as needed
import Footer from '../components/Footer'; // Adjust path as needed

const PrivacyPolicy = () => {

 

  return (
    <>

      <Navbar />
      <div className="container-fluid" style={{ backgroundColor: 'white' }}>
        <div className="row justify-content-center align-items-center" style={{ marginRight: '-12px', marginLeft: '-12px' }}>
          <div className="col-8 text-center">
            <h1 className="pt-4 text-instagram"><strong>Privacy Policy</strong></h1>
          </div>
        </div>
        <div className="row justify-content-center text-center mt-5">
          <div id="pricing" style={{ fontSize: '15px', width: '100%' }}>
            <p>
              Thank you for choosing <span className="text-instagram">RizzUp</span> LLC ("<span className="text-instagram">RizzUp</span>", "we", "us", or "our") for your Instagram growth services. Protecting your privacy is important to us. This Privacy Policy explains how we collect, use, and disclose your personal information.
            </p>
            <p>
              <strong>Information We Collect:</strong> We collect personal information that you provide to us when you create an account, purchase our Services, or communicate with us. This may include your name, email address, billing address, and payment information. We also collect non-personal information such as your IP address, browser type, and operating system when you visit our Site or use our Services.
            </p>
            <p>
              <strong>How We Use Your Information:</strong> We use your personal information to provide you with our Services, process your payments, communicate with you about your account, and send you promotional materials. We also use non-personal information to analyze usage patterns on our Site and improve our Services.
            </p>
            <p>
              <strong>Sharing Your Information:</strong> We do not sell, trade, or rent your personal information to third parties. We may disclose your personal information to our trusted service providers who assist us in providing our Services, such as payment processors and email providers. We require these service providers to protect your personal information and only use it for the purposes for which it was disclosed. We may also disclose your personal information if required by law or in response to a court order, subpoena, or other legal process.
            </p>
            <p>
              <strong>Data Retention:</strong> We retain your personal information for as long as necessary to provide you with our Services and for as long as required by law.
            </p>
            <p>
              <strong>Security:</strong> We take reasonable measures to protect your personal information from unauthorized access, disclosure, or alteration. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee the absolute security of your personal information.
            </p>
            <p>
              <strong>Children's Privacy:</strong> Our Site and Services are not intended for children under the age of 13. We do not knowingly collect personal information from children under the age of 13. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us at <span className="text-instagram">support@rizzup.net</span>.
            </p>
            <p>
              <strong>Changes to this Privacy Policy:</strong> We may update this Privacy Policy from time to time. We will post the updated Privacy Policy on our Site and indicate the date of the last revision. Your continued use of our Site or Services after the updated Privacy Policy is posted will constitute your acceptance of the updated Privacy Policy.
            </p>
            <p>
              <strong>Contact Information:</strong> If you have any questions or concerns regarding this Privacy Policy, please contact us at <span className="text-instagram">support@rizzup.net</span>.
            </p>
            <p>
              By using our Site or Services, you agree to this Privacy Policy. If you do not agree to this Privacy Policy, you may not use our Site or Services.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
